export default "__VITE_ASSET__CmrXROcF__"